// extracted by mini-css-extract-plugin
export default {"background":"cover_background__ml-yR"};